/** Saves bytes or text as a file through the browser's download (nothing leaves the device). */
export function downloadFile(name: string, data: string | Uint8Array, type: string): void {
  const blob = new Blob([data as BlobPart], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}

/** A file name from a song title: letters, digits, spaces, dashes. */
export function safeFileName(title: string): string {
  return title.replace(/[^\p{L}\p{N} _-]+/gu, '').trim() || 'chords';
}
